import { ColDef } from "ag-grid-community";
import { CustomCellRendererProps } from "ag-grid-react";
import { TaskStatusCellRenderer } from "@/components/pages/common/ag-grid/components/common-cell-renderers/TaskStatusCellRenderer";

export const taskColumnDef: ColDef = {
  minWidth: 210,
  sortable: false,
  field: "resource.task",
  headerName: "Task Status",
  valueGetter: ({ data }) => {
    const taskId = data?.resource?.task?.id;
    return taskId
      ? `Link To Task: ${window.location.origin}/task-mgmt?taskId=${data?.resource?.task?.id}`
      : "-";
  },
  cellRenderer: ({ data }: CustomCellRendererProps) =>
    data?.resource?.task ? (
      <TaskStatusCellRenderer task={data.resource.task} />
    ) : (
      "-"
    ),
};
